import { isTablet } from 'react-device-detect';

import OverlayBg from '@public/images/overlay/overlay-bg.png';
import OverlayLandscapeBg from '@public/images/overlay/overlay-landscape-bg.png';
import { colors } from '@constants/colors';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { appTheme } = useMytaverse();

  const {
    submitButton: { backgroundColor, backgroundColorHover },
  } = appTheme.avatarPage.assets;

  return {
    root: (isLogoHidden: boolean) => ({
      position: 'fixed',
      top: 0,
      display: 'grid',
      gridTemplateRows: 'auto 1fr',
      backgroundColor: colors.white,
      width: '100%',
      height: '100%',
      background: `url(${OverlayBg})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      zIndex: 1200,
      paddingLeft: 2,
      paddingRight: 2,

      '& a': {
        display: isLogoHidden ? 'none' : 'flex',
      },

      [`@media only screen and (max-height: 575.98px) and (max-device-width: 750px) and (orientation: landscape)`]:
        {
          background: `url(${OverlayLandscapeBg})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',

          '& a': {
            display: 'none',
          },
        },
    }),
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      flexDirection: 'column',
      gap: 2,
      overflow: 'auto',

      [`@media screen and (orientation:landscape)
        and (max-device-height: 760px)
        and (max-device-width: 1180px)`]: {
        gap: 1,
        justifyContent: 'start',
        marginTop: '-60px',
      },
      [`@media screen and (orientation:landscape)
        and (max-device-height: 650px)
        and (max-device-width: 1180px)`]: {
        gap: 1,
        justifyContent: 'start',
        marginTop: '-60px',
      },
      [`@media screen and (orientation:landscape)
        and (max-device-height: 570px)
        and (max-device-width: 900px)`]: {
        gap: 1,
        justifyContent: 'start',
        marginTop: '-60px',
      },
      [`@media only screen and (max-height: 575.98px) and (max-device-width: 750px) and (orientation: landscape)`]:
        {
          gap: 1,
          justifyContent: 'start',
          marginTop: '-10px',
        },

      [`@media only screen and (max-height: 340px) and (max-device-width: 750px) and (orientation: landscape)`]:
        {
          marginTop: '-60px',
        },
    },
    content: {
      width: '84%',
      textAlign: 'center',
      marginBottom: 4,
    },
    keyboardIcon: {
      width: 64,
      height: 64,
      color: colors.grey,
      marginBottom: isTablet ? '53px' : '33px',
    },
    title: {
      fontFamily: 'Primary-Bold',
      fontSize: 32,
      lineHeight: '44px',
      color: colors.black,
      marginBottom: '12px',
    },
    description: {
      fontWeight: 500,
      fontSize: 16,
      lineHeight: '22px',
      color: '#707070',
    },
    boldText: {
      inherit: 'all',
      fontWeight: 600,
    },
    button: (isVisible: boolean, fullWidth = false) => ({
      width: fullWidth ? '100%' : 'auto',
      maxWidth: '365px',
      color: colors.white,
      fontWeight: 500,
      background: backgroundColor,
      borderRadius: '99px',
      fontSize: 20,
      lineHeight: '24px',
      textTransform: 'none',
      display: isVisible ? 'block' : 'none',
      mb: '10px',
      padding: '16px 32px',

      '&:hover': {
        background: backgroundColorHover,
      },

      [`@media only screen and (max-height: 575.98px) and (max-device-width: 750px) and (orientation: landscape)`]:
        {
          display: 'block',
        },
    }),
    skipButton: {
      background: 'transparent',
      color: colors.grey,
    },
  };
};
